export const USER_CONTENTS = [
  {
    title: 'Allison & Benjamin’s',
    excerpt:
      '<p>In January 2021, in the midst of a global pandemic, two adventurous souls found themselves drawn together by a shared love for bouldering. Meet Ally and Ben, whose serendipitous meeting at the Hive Climbing Gym would set the stage for a love story that would potentially go down as the greatest in Canadian history (no bias, of course).' +
      'One fateful afternoon, Allison, a full-time career gal with a love for bouldering, found herself at the climbing gym. She navigated the colourful holds and challenging routes with grace and determination. Little did she know that her path would soon intersect with that of Ben, a regular climber who was a full-time University student squeezing the most out of his flexible schedule to work on a challenging route in the early afternoon.' +
      'Ben attempted a difficult new route in which he fell off and instantly hurt his left ring finger. Unknowingly, Allison encouraged him on his attempt. Captivated by her enthusiasm (and bright blue ’white walker’ eyes) Ben couldn’t resist striking up a conversation. They got to talking, and talking turned into an hour. Before parting ways, Allison gave Ben her number in hopes to have a new ‘climbing buddy’. But to both of their excitement, their chemistry ignited a spark for which friendship just would not do.' +
      'Their friendship and connection grew stronger with each shared adventure, and it wasn’t long before they realized they had found something special in each other. Despite the challenges of the pandemic, Ben and Ally were creative in dates from ocean side walks, hammocking in the forest, to homemade pizza nights in.' +
      'After laughing through two years as partners in crime, these two adventurers recognized this was the adventure to commit their lives to.</p>',
    mediaLink: 'registry/registry-user-content/allison-benjamin/wedding-registry.jpg',
    registryProducts: [
      {
        imageUrl: 'registry/registry-user-content/allison-benjamin/registry-product-1.jpg',
        shopUrl: '/shop/item/b2087226-2924-5c18-9433-923e666c67e5',
      },
      {
        imageUrl: 'registry/registry-user-content/allison-benjamin/registry-product-2.jpg',
        shopUrl: '/shop/item/088ccca7-d371-52f5-80d5-a41f28a3b282',
      },
      {
        imageUrl: 'registry/registry-user-content/allison-benjamin/registry-product-3.jpg',
        shopUrl: '/shop/item/67a564a1-9c69-599e-b85c-3348bfef6ae7',
      },
      {
        imageUrl: 'registry/registry-user-content/allison-benjamin/registry-product-4.jpg',
        shopUrl: '/shop/item/06ec4507-2aef-5338-b9fd-f6a330f0051e',
      },
      {
        imageUrl: 'registry/registry-user-content/allison-benjamin/registry-product-5.jpg',
        shopUrl: '/shop/item/f2839759-cd00-526e-9c98-0bc47e7302fc',
      },
      {
        imageUrl: 'registry/registry-user-content/allison-benjamin/registry-product-6.jpg',
        shopUrl: '/shop/item/ca9700fd-6323-543f-acdd-a1470c164d0f',
      },
    ],
  },
  {
    title: 'Thomas & Bryana’s',
    excerpt:
      '<p>The first time we met, we were both playing a riveting game of “Titanic” in one of those team-building exercises that we all know and love. I remember thinking, well if I’m stuck on a doomed ship, being stuck with her wouldn’t be so bad—we both ended up drowned. Then a few months later I began flirting with her. “Hey” I would say and then I would wonder why she wasn’t picking up what I was putting down. Eventually, I decided that I would need to up my game, so under the guise of planning a friend’s going away party, we set off to venture for a pinata. One party planning venture, a trip to REI, many walks later, and I find myself about to embark on the next adventure with the most beautiful, smart, and amazing woman I’ve ever met.</p>' +
      '-Thomas</p>',
    mediaLink: 'registry/registry-user-content/thomas-bryana/wedding-registry.jpg',
    registryProducts: [
      {
        imageUrl: 'registry/registry-user-content/thomas-bryana/registry-product-1.jpg',
        shopUrl: '/shop/item/c1a07a84-3633-5afe-9e39-91ccec0a06cd',
      },
      {
        imageUrl: 'registry/registry-user-content/thomas-bryana/registry-product-2.jpg',
        shopUrl: '/shop/item/e63871ed-f904-52a4-8415-3c0d97d7293f',
      },
      {
        imageUrl: 'registry/registry-user-content/thomas-bryana/registry-product-3.jpg',
        shopUrl: '/shop/item/7f30b721-7b30-5a6f-a4aa-dab7ea41452f',
      },
      {
        imageUrl: 'registry/registry-user-content/thomas-bryana/registry-product-4-ver2.jpg',
        shopUrl: '/shop/item/b843296f-90d0-5e5a-8ce6-75cf2a59ed33',
      },
      {
        imageUrl: 'registry/registry-user-content/thomas-bryana/registry-product-5.jpg',
        shopUrl: '/shop/item/12ff7d14-6297-5865-94ad-887eb0933ffa',
      },
      {
        imageUrl: 'registry/registry-user-content/thomas-bryana/registry-product-6.jpg',
        shopUrl: '/shop/item/f5d9400e-4661-58a2-9da2-0ee5df2db71a',
      },
    ],
  },
  {
    title: 'Taylor & Efe’s',
    excerpt:
      '<p>It was a beautiful day in August of 2018, and Taylor was at Pickles Pub across from Camden Yards with her friends Erin and Anthony. Taylor was being set up with their friend Dylan. She was quite recently single and was only allowing this setup to happen to appease her friend Erin.</p>' +
      '<p>Pano to Efe: Dylan told Efe that he had an extra ticket to the Orioles game (Taylor’s ticket) and invited him to join. Right before they arrive to Pickles, Dylan turns to Efe, explains he’s being set up, and tells Efe he’s not interested (Taylor’s Facebook profile was lackluster it seems.) But when they both see Taylor, Dylan trys to take it back. They both talk over each other trying to buy Taylor drinks, which continues throughout the Orioles game.</p>' +
      '<p>What Dylan didn’t know was that he had lost the moment Taylor saw Efe. Green eyes and black hair, totally her type. And he’s Turkish! How interesting! The five of them spent the whole day together, as baseball games are rather long. The fact that both Efe and Taylor were around their friends made it apparent that they were being their authentic selves, and so Taylor was blunt and Efe was silly. At dinner at the end of the day, Efe slid a napkin across the table, asking Taylor for her number :)</p>' +
      '<p>The next day, Efe told his friend Conor, “I really hope it works out with this girl!”</p>',
    mediaLink: 'registry/registry-user-content/taylor-efe/wedding-registry.jpg',
    registryProducts: [
      {
        imageUrl: 'registry/registry-user-content/taylor-efe/registry-product-1.jpg',
        shopUrl: '/shop/item/ac4a5758-78ad-59c0-9cf5-c4597d689d83',
      },
      {
        imageUrl: 'registry/registry-user-content/taylor-efe/registry-product-2.jpg',
        shopUrl: '/shop/item/79fc7476-049b-5611-a443-12cb182326c8',
      },
      {
        imageUrl: 'registry/registry-user-content/taylor-efe/registry-product-3.jpg',
        shopUrl: '/shop/item/c13c3ba9-7d0f-52e1-88e4-387e2fe7fc8a',
      },
      {
        imageUrl: 'registry/registry-user-content/taylor-efe/registry-product-4.jpg',
        shopUrl: '/shop/item/3a492a8e-14cd-58ad-96fc-791ac5e05a04',
      },
      {
        imageUrl: 'registry/registry-user-content/taylor-efe/registry-product-5.jpg',
        shopUrl: '/shop/item/4b7cb036-ada6-5de2-ac82-1c6e2f0d6773',
      },
      {
        imageUrl: 'registry/registry-user-content/taylor-efe/registry-product-6.jpg',
        shopUrl: '/shop/item/ee30a91a-1ccb-5e10-bfd1-132bf3fd636f',
      },
    ],
  },
  {
    title: 'Makeya & Bre’Kean’s',
    excerpt:
      '<p>Ken and I were invited to an event to celebrate someone we love. I arrived at the event first and became acquainted with my friend’s family, a.k .a. his family. Little did I, or shall I say we, know that My friend’s family was playing matchmakers, and when Bre’kean arrived, we were both strongly encouraged to speak. We had small conversations, and then it was time for me to leave.</p>' +
      '<p>However, as you may know, when we make plans, God laughs because as I was trying to leave, my tire caught a flat, and Bre’Kean put on the spare and made sure I got home safely. Our story continued, and for a few weeks, we dated and had long conversations, and both realized that we wanted to be together. So, we made it official!</p>',
    mediaLink: 'registry/registry-user-content/makeya-brekean/wedding-registry.jpg',
    registryProducts: [
      {
        imageUrl: 'registry/registry-user-content/makeya-brekean/registry-product-1.jpg',
        shopUrl: '/shop/item/2b398853-f49e-5b3f-b4a3-52866e12e0e0',
      },
      {
        imageUrl: 'registry/registry-user-content/makeya-brekean/registry-product-2.jpg',
        shopUrl: '/shop/item/87e3e544-904b-55ef-973e-3bc94e68f30a',
      },
      {
        imageUrl: 'registry/registry-user-content/makeya-brekean/registry-product-3.jpg',
        shopUrl: '/shop/item/1afb6af1-2db6-51ed-b886-041c5ae21a87',
      },
      {
        imageUrl: 'registry/registry-user-content/makeya-brekean/registry-product-4.jpg',
        shopUrl: '/shop/item/a22ea4e4-e40b-5b4c-84b2-47423847e614',
      },
      {
        imageUrl: 'registry/registry-user-content/makeya-brekean/registry-product-5.jpg',
        shopUrl: '/shop/item/cc657aab-5b71-50e7-ab64-3200fff45363',
      },
      {
        imageUrl: 'registry/registry-user-content/makeya-brekean/registry-product-6.jpg',
        shopUrl: '/shop/item/8cc1e60d-e1a1-50ed-b278-9adb18bc8e15',
      },
    ],
  },
  {
    title: 'Morgan & Gray’s',
    excerpt:
      '<p>Gray and Morgan met on November 19, 2021, at an engagement party on Folly Beach. Gray attended the University of South Carolina with the future groom, and Morgan went to Clemson University with the future bride (thank you, Brunsons!).</p>' +
      '<p>Morgan briefly talked to Gray at the party, then a few days passed, and she decided to follow him on Instagram (she thought he was super cute, so why not?). He immediately reached out to her, and the rest is history.</p>' +
      '<p>Their first date was Downtown Charleston at Barsa on December 1, 2021. After dinner, the two grabbed espresso martinis at Vintage Lounge for dessert.</p>' +
      '<p>On December 24, 2023 (Christmas Eve!), Gray proposed at Morgan’s Nana and Papa’s house (her mom’s parents) in front of her family.</p>' +
      '<p>To give a glimpse of Gray’s heart, as they headed back to Morgan’s parents’ house that day, with tears in his eyes, Gray told her that he knew he wanted to propose in front of her family because ever since the first time he met them, they have always made him feel like family.<p>' +
      '<p>Morgan thanks God every day for bringing Gray into her life. He is proof that God always gives us His very best, and she couldn’t be more grateful that she gets to love him forever.</p>',
    mediaLink: 'registry/registry-user-content/morgan-gray/wedding-registry.jpg',
    registryProducts: [
      {
        imageUrl: 'registry/registry-user-content/morgan-gray/registry-product-1-ver2.jpg',
        shopUrl: '/shop/item/5ccd23ca-1e55-5877-b772-0e0e1bd1b580',
      },
      {
        imageUrl: 'registry/registry-user-content/morgan-gray/registry-product-2.jpg',
        shopUrl: '/shop/item/aca7d7bc-40a8-5547-bead-e744f443f5c7',
      },
      {
        imageUrl: 'registry/registry-user-content/morgan-gray/registry-product-3-ver2.jpg',
        shopUrl: '/shop/item/ddc89db8-d8e6-5b00-8c32-e33e243df8ef',
      },
      {
        imageUrl: 'registry/registry-user-content/morgan-gray/registry-product-4.jpg',
        shopUrl: '/shop/item/379b6c78-ff16-5bd5-91a7-5090fa842c3b',
      },
      {
        imageUrl: 'registry/registry-user-content/morgan-gray/registry-product-5-ver2.jpg',
        shopUrl: '/shop/item/e8a50931-d1fa-5361-9e97-0441235e5427',
      },
      {
        imageUrl: 'registry/registry-user-content/morgan-gray/registry-product-6.jpg',
        shopUrl: '/shop/item/c6f82261-9432-5fc7-a560-7b38a9bbf576',
      },
    ],
  },
  {
    title: 'Katie & Ryan’s',
    excerpt:
      '<p>We first met in the most magical place on earth--Bumble, where the woman is forced to make the first move. As Katie continued to make the big moves,' +
      ' Ryan stayed along for the ride as he always does. From our first date at Cityside in Brighton, we both knew that our bond over dogs, 90s music, good food,' +
      ' and the Great British Bake off could lead to something more than just a first date. After that, we were inseparable and there was never a question about spending the rest of our lives together.' +
      ' We’ve raised a dog, grieved together, traveled across the world, fallen in love, and moved in together, but we are most excited to get married and spend the rest of our lives together.</p>',
    mediaLink: 'registry/registry-user-content/katie-ryan/wedding-registry-ver-2.jpg',
    registryProducts: [
      {
        imageUrl: 'registry/registry-user-content/katie-ryan/registry-product-1.jpg',
        shopUrl: '/shop/item/0a72715d-2baf-52e9-8679-fb0ffb1ba393',
      },
      {
        imageUrl: 'registry/registry-user-content/katie-ryan/registry-product-2.jpg',
        shopUrl: '/shop/item/a13a4496-e36e-57fb-8b44-b17231c8cdc3',
      },
      {
        imageUrl: 'registry/registry-user-content/katie-ryan/registry-product-3.jpg',
        shopUrl: '/shop/item/cd1f25f6-5853-5f42-aecd-5ae146124b3e',
      },
      {
        imageUrl: 'registry/registry-user-content/katie-ryan/registry-product-4.jpg',
        shopUrl: '/shop/item/a4b90498-2e9c-55ab-b4db-451a26b50526',
      },
      {
        imageUrl: 'registry/registry-user-content/katie-ryan/registry-product-5.jpg',
        shopUrl: '/shop/item/3ac07e2b-087f-5b0b-b545-d203b8c049b0',
      },
      {
        imageUrl: 'registry/registry-user-content/katie-ryan/registry-product-6.jpg',
        shopUrl: '/shop/item/bf81b563-d5c4-5b54-86bf-ba6de708f62e',
      },
    ],
  },
  {
    title: 'Darya & Jesse’s',
    excerpt:
      '<p>Darya and Jesse met in the summer of 2016. Jesse was having a BBQ at his house in Felton and Darya stopped by with a mutual friend.</p>' +
      '<p>They started talking and connected over their shared love of art and music. As fate would have it, not only did they live close to one another, but they worked just one block apart in downtown Santa Cruz</p>' +
      '<p>Darya often went to New Leaf Market, where Jesse worked, on her lunch break. They’d wave to each other in the check out line and it wasn’t long before they took their friendship to the next level. Their first date was at Monty’s Log Cabin, a favorite local dive bar in the redwoods</p>' +
      '<p>As their relationship grew they moved into their first apartment together, traveled to new places, and adopted their first puppy named Scout.</p>' +
      '<p>Some of their favorite travel memories together have been riding bikes through tulip fields in Amsterdam, and traveling by camper van to hike the red rocks of Sedona, Arizona.</p>' +
      '<p>Jesse received his masters degree from CSUMB and started his teaching career at Watsonville Highschool while Darya started medical assisting at the Capitola Health Center, and found her passion in creating stained glass art</p>' +
      '<p>On their 6 year anniversary, they took a ride up the coast on Jesse’s motorcycle and had a picnic overlooking the Pacific Ocean. Jesse got down on one knee and proposed to Darya at sunset. She, of course, said "YES!"</p>',
    mediaLink: 'registry/registry-user-content/dariya-jesse/wedding-registry-ver-3.jpg',
    registryProducts: [
      {
        imageUrl: 'registry/registry-user-content/dariya-jesse/registry-product-1.jpg',
        shopUrl: '/shop/catalog/honeymoon',
      },
      {
        imageUrl: 'registry/registry-user-content/dariya-jesse/registry-product-2.jpg',
        shopUrl: '/shop/catalog/honeymoon',
      },
      {
        imageUrl: 'registry/registry-user-content/dariya-jesse/registry-product-3.jpg',
        shopUrl: '/shop/catalog/honeymoon',
      },
      {
        imageUrl: 'registry/registry-user-content/dariya-jesse/registry-product-4.jpg',
        shopUrl: '/shop/catalog/honeymoon',
      },
    ],
  },
];
